import { render, staticRenderFns } from "./AverageOccupancyCities.vue?vue&type=template&id=99753980"
import script from "./AverageOccupancyCities.vue?vue&type=script&lang=js"
export * from "./AverageOccupancyCities.vue?vue&type=script&lang=js"
import style0 from "./AverageOccupancyCities.vue?vue&type=style&index=0&id=99753980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports